import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import { Option } from '../Option';
import { Modal } from '../Modal';
import { Portal } from '../Portal';
import clsx from 'clsx';

var Menu = function Menu(_ref) {
  var _clsx;

  var options = _ref.options,
      selected = _ref.selected,
      onSelect = _ref.onSelect,
      _ref$closeOnSelect = _ref.closeOnSelect,
      closeOnSelect = _ref$closeOnSelect === void 0 ? true : _ref$closeOnSelect,
      setOpen = _ref.setOpen,
      parent = _ref.parent,
      positioning = _ref.positioning,
      _ref$interpolation = _ref.interpolation,
      interpolation = _ref$interpolation === void 0 ? {} : _ref$interpolation,
      _ref$menuStyles = _ref.menuStyles,
      menuStyles = _ref$menuStyles === void 0 ? {} : _ref$menuStyles,
      _ref$modalStyles = _ref.modalStyles,
      modalStyles = _ref$modalStyles === void 0 ? {} : _ref$modalStyles,
      _ref$customClassName = _ref.customClassName,
      customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName,
      _ref$modalClassName = _ref.modalClassName,
      modalClassName = _ref$modalClassName === void 0 ? '' : _ref$modalClassName,
      _ref$modalProps = _ref.modalProps,
      modalProps = _ref$modalProps === void 0 ? {} : _ref$modalProps;
  var classes = useStyles();
  var innerContainerStyle = clsx((_clsx = {}, _defineProperty(_clsx, classes.innerContainer, true), _defineProperty(_clsx, customClassName, Boolean(customClassName)), _clsx));

  var onSelectOption = function onSelectOption(option) {
    onSelect(option);
    if (closeOnSelect) setOpen(false);
  };

  var composedModalProps = Object.assign({
    parent: parent,
    positioning: positioning,
    setOpen: setOpen,
    customClassName: modalClassName,
    interpolation: interpolation,
    inlineStyles: modalStyles
  }, modalProps);
  return React.createElement(Portal, null, React.createElement(Modal, Object.assign({}, composedModalProps), React.createElement("div", {
    className: innerContainerStyle,
    style: menuStyles
  }, options.map(function (option) {
    return React.createElement(Option, {
      key: option.id,
      option: option,
      onSelectOption: onSelectOption,
      active: option.id === (selected === null || selected === void 0 ? void 0 : selected.id)
    });
  }))));
};

Menu.propTypes = {
  options: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    handler: PropTypes.func
  }),
  closeOnSelect: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  parent: PropTypes.instanceOf(Element),
  positioning: PropTypes.object,
  interpolation: PropTypes.object,
  menuStyles: PropTypes.object,
  modalStyles: PropTypes.object,
  customClassName: PropTypes.string,
  modalClassName: PropTypes.string,
  modalProps: PropTypes.shape({
    setOpen: PropTypes.func.isRequired,
    parent: PropTypes.instanceOf(Element),
    positioning: PropTypes.shape({
      anchor: PropTypes.shape({
        x: PropTypes.oneOf(['left', 'center', 'right']).isRequired,
        y: PropTypes.oneOf(['top', 'center', 'bottom']).isRequired
      }),
      offset: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
      })
    }),
    customClassName: PropTypes.string,
    interpolation: PropTypes.object,
    node: PropTypes.string
  })
};
export { Menu };